export const handleArrCheck = (arr, data) => {
  if (arr[0] === 0) return data?.toString()
  if (arr.includes(data)) {
    return arr.filter((item) => item !== data)?.toString()
  }
  return [...arr, data]?.toString()
}
